import {
  FETCH_ACCOUNT_VEHICLE_INIT,
  FETCH_ACCOUNT_VEHICLE_SUCCESS,
  FETCH_ACCOUNT_VEHICLE_FAILURE,
  FETCH_ACCOUNT_VEHICLE_EXTENDED_PROPERTIES_INIT,
  FETCH_ACCOUNT_VEHICLE_EXTENDED_PROPERTIES_SUCCESS,
  FETCH_ACCOUNT_VEHICLE_EXTENDED_PROPERTIES_FAILURE,
  FETCH_ACCOUNT_VEHICLE_COUNT_INIT,
  FETCH_ACCOUNT_VEHICLE_COUNT_SUCCESS,
  FETCH_ACCOUNT_VEHICLE_COUNT_FAILURE,
  FETCH_ACCOUNT_VEHICLE_NO_LOADING_INIT,
  FETCH_ACCOUNT_VEHICLE_NO_LOADING_SUCCESS,
  FETCH_ACCOUNT_VEHICLE_NO_LOADING_FAILURE,
  SAVE_ACCOUNT_VEHICLE_INIT,
  SAVE_ACCOUNT_VEHICLE_SUCCESS,
  SAVE_ACCOUNT_VEHICLE_FAILURE,
  UPDATE_ACCOUNT_VEHICLE_INIT,
  UPDATE_ACCOUNT_VEHICLE_SUCCESS,
  UPDATE_ACCOUNT_VEHICLE_FAILURE,
  DELETE_ACCOUNT_VEHICLE_INIT,
  DELETE_ACCOUNT_VEHICLE_SUCCESS,
  DELETE_ACCOUNT_VEHICLE_FAILURE,
  RESET_MODAL,
  RESET_ACCOUNT_VEHICLE,
  FETCH_DOWNLOAD_ACCOUNT_VEHICLE_SUCCESS,
  FETCH_DOWNLOAD_ACCOUNT_VEHICLE_FAILURE,
  FETCH_DOWNLOAD_ACCOUNT_VEHICLE_INIT,
  FETCH_UPLOAD_ACCOUNT_VEHICLE_SUCCESS,
  FETCH_UPLOAD_ACCOUNT_VEHICLE_FAILURE,
  FETCH_UPLOAD_ACCOUNT_VEHICLE_INIT,
  RESET_MODAL_FILE,
  ACTIVE_ACCOUNT_VEHICLE_INIT,
  ACTIVE_ACCOUNT_VEHICLE_SUCCESS,
  ACTIVE_ACCOUNT_VEHICLE_FAILURE,
} from './types';
import API from './api';
import utilFunction from '../../containers/function';

/* Actions Creators */
export function resetModalFileVehicleAccount() {
  return {
    type: RESET_MODAL_FILE,
  };
}

export function resetModalVehicle() {
  return {
    type: RESET_MODAL,
  };
}

export function resetAccountVehicle() {
  return {
    type: RESET_ACCOUNT_VEHICLE,
  };
}

/* Account Vehicle */

function fetchApiSuccess(data) {
  return {
    type: FETCH_ACCOUNT_VEHICLE_SUCCESS,
    payload: data,
  };
}

function fetchApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_ACCOUNT_VEHICLE_FAILURE,
    payload: error,
  };
}

function fetchApiInit() {
  return {
    type: FETCH_ACCOUNT_VEHICLE_INIT,
  };
}

export function fetchAccountVehicleApi(obj) {
  return async (dispatch) => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);

      // Sort data by alias in ascending order if see is true
      if (obj.see && data && data.data && data.data.length > 0) {
        const sortedData = utilFunction.sortByField(data.data, 'alias', 'ASC');
        data.data = sortedData;
      }

      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Account Vehicle no loading */

function fetchApiNoLoadingSuccess(data,concat) {
  return {
    type: FETCH_ACCOUNT_VEHICLE_NO_LOADING_SUCCESS,
    payload: data,
    concat: concat
  };
}

function fetchApiNoLoadingFailure(error) {
  console.log(error)
  return {
    type: FETCH_ACCOUNT_VEHICLE_NO_LOADING_FAILURE,
    payload: error,
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_ACCOUNT_VEHICLE_NO_LOADING_INIT,
  };
}

export function fetchAccountVehicleNoLoadingApi(obj) {
  return async (dispatch) => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiNoLoadingFailure(error));
    }
  };
}

/* Vehicle Save (Async) */

function saveApiSuccess(data) {
  return {
    type: SAVE_ACCOUNT_VEHICLE_SUCCESS,
    payload: data,
  };
}

function saveApiFailure(error) {
  return {
    type: SAVE_ACCOUNT_VEHICLE_FAILURE,
    errorSave: error,
  };
}

function saveApiInit() {
  return {
    type: SAVE_ACCOUNT_VEHICLE_INIT,
  };
}

export function handleVehicle(data) {
  return async (dispatch) => {
    dispatch(saveApiInit());
    try {
      const resp = await API.data.handleVehicle(data);
      return dispatch(saveApiSuccess(resp));
    } catch (error) {
      return dispatch(saveApiFailure(error));
    }
  };
}

/* Vehicle Update (Async) */

function updateApiSuccess(data) {
  return {
    type: UPDATE_ACCOUNT_VEHICLE_SUCCESS,
    payload: data,
  };
}

function updateApiFailure(error) {
  return {
    type: UPDATE_ACCOUNT_VEHICLE_FAILURE,
    errorupdate: error,
  };
}

function updateApiInit() {
  return {
    type: UPDATE_ACCOUNT_VEHICLE_INIT,
  };
}

export function handleUpdateVehicle(data) {
  return async (dispatch) => {
    dispatch(updateApiInit());
    try {
      const resp = await API.data.handleUpdateVehicle(data);
      return dispatch(updateApiSuccess(resp));
    } catch (error) {
      return dispatch(updateApiFailure(error));
    }
  };
}


/* Vehicle Delete (Async) */

function deleteApiSuccess(data) {
  return {
    type: DELETE_ACCOUNT_VEHICLE_SUCCESS,
    payload: data,
  };
}

function deleteApiFailure(error) {
  return {
    type: DELETE_ACCOUNT_VEHICLE_FAILURE,
    errordelete: error,
  };
}

function deleteApiInit() {
  return {
    type: DELETE_ACCOUNT_VEHICLE_INIT,
  };
}

export function handleDeleteVehicle(data) {
  return async (dispatch) => {
    dispatch(deleteApiInit());
    try {
      const resp = await API.data.handleDeleteVehicle(data);
      return dispatch(deleteApiSuccess(resp));
    } catch (error) {
      return dispatch(deleteApiFailure(error));
    }
  };
}

/* Account Vehicle EXTENDED PROPERTIES */

function fetchApiExtendedPropertiesSuccess(data) {
  return {
    type: FETCH_ACCOUNT_VEHICLE_EXTENDED_PROPERTIES_SUCCESS,
    payload: data
  };
}

function fetchApiExtendedPropertiesFailure(error) {
  console.log(error);
  return {
    type: FETCH_ACCOUNT_VEHICLE_EXTENDED_PROPERTIES_FAILURE,
    payload: error
  };
}

function fetchApiExtendedPropertiesInit() {
  return {
    type: FETCH_ACCOUNT_VEHICLE_EXTENDED_PROPERTIES_INIT
  };
}

export function fetchAccountVehicleExtendedPropertiesApi(obj) {
  return async dispatch => {
    dispatch(fetchApiExtendedPropertiesInit());
    try {
      let data = await API.data.getExtendedProperties(obj);
      dispatch(fetchApiExtendedPropertiesSuccess(data));
    } catch (error) {
      dispatch(fetchApiExtendedPropertiesFailure(error));
    }
  };
}

/* Account Vehicle COUNT */

function fetchApiCountSuccess(data) {
  return {
    type: FETCH_ACCOUNT_VEHICLE_COUNT_SUCCESS,
    payload: data,
  };
}

function fetchApiCountFailure(error) {
  console.log(error)
  return {
    type: FETCH_ACCOUNT_VEHICLE_COUNT_FAILURE,
    payload: error,
  };
}

function fetchApiCountInit() {
  return {
    type: FETCH_ACCOUNT_VEHICLE_COUNT_INIT,
  };
}

export function fetchAccountVehicleCountApi(obj) {
  return async (dispatch) => {
    dispatch(fetchApiCountInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchApiCountSuccess(data));
    } catch (error) {
      dispatch(fetchApiCountFailure(error));
    }
  };
}

/* get download file */

function fetchDownloadApiSuccess(data) {
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_VEHICLE_SUCCESS,
    payload: data,
  };
}

function fetchDownloadApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_VEHICLE_FAILURE,
    payload: error,
  };
}

function fetchDownloadApiInit() {
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_VEHICLE_INIT,
  };
}

export function fetchAccountVehicleDownloadApi(group,tags) {
  return async (dispatch) => {
    dispatch(fetchDownloadApiInit());
    try {
      let data = await API.data.handleVehicleDownload(group, tags);
      dispatch(fetchDownloadApiSuccess(data));
    } catch (error) {
      dispatch(fetchDownloadApiFailure(error));
    }
  };
}

/* get download file */

function fetchUploadApiSuccess(data) {
  return {
    type: FETCH_UPLOAD_ACCOUNT_VEHICLE_SUCCESS,
    payload: data,
  };
}

function fetchUploadApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_UPLOAD_ACCOUNT_VEHICLE_FAILURE,
    payload: error,
  };
}

function fetchUploadApiInit() {
  return {
    type: FETCH_UPLOAD_ACCOUNT_VEHICLE_INIT,
  };
}

export function fetchAccountVehicleUploadApi(group,tags) {
  return async (dispatch) => {
    dispatch(fetchUploadApiInit());
    try {
      let data = await API.data.handleVehicleUpload(group, tags);
      dispatch(fetchUploadApiSuccess(data));
    } catch (error) {
      dispatch(fetchUploadApiFailure(error));
    }
  };
}

/* Active Vehicle (Async) */

function activeApiSuccess(data) {
  return {
    type: ACTIVE_ACCOUNT_VEHICLE_SUCCESS,
    payload: data,
  };
}

function activeApiFailure(error) {
  return {
    type: ACTIVE_ACCOUNT_VEHICLE_FAILURE,
    errordelete: error,
  };
}

function activeApiInit() {
  return {
    type: ACTIVE_ACCOUNT_VEHICLE_INIT,
  };
}

export function handleActiveVehicle(data) {
  return async (dispatch) => {
    dispatch(activeApiInit());
    try {
      const resp = await API.data.handleActiveVehicle(data);
      return dispatch(activeApiSuccess(resp));
    } catch (error) {
      return dispatch(activeApiFailure(error));
    }
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/account_vehicle/index.js